import { withRouter } from 'react-router-dom';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent } from 'client/data/models/cms';
import { getCmsPathForPage } from 'site-modules/lease-deals/utils/get-cms-path-for-page';

export function withCmsContent(Component) {
  return withRouter(
    connectToModel(Component, {
      content: bindToContent(({ match, location }) =>
        getCmsPathForPage({ matchPath: match.path, pathname: location.pathname })
      ),
    })
  );
}
